import { OrderConfirmationHeader} from "../OrderConfirmationHeader";
import { OrderConfirmationStops} from "../OrderConfirmationStops";
import { Button, DataSource, Label, Layout, Map, Panel, Textbox} from "@mcleod/components";

export abstract class AutogenLayoutFtlOrderConfirmation extends Layout {
	buttonShare: Button;
	labelAddlDetails: Label;
	labelLabel2: Label;
	labelOrderNumber: Label;
	layoutHeader: OrderConfirmationHeader;
	layoutStops: OrderConfirmationStops;
	mapStops: Map;
	panelAddlDetails: Panel;
	panelLeft: Panel;
	panelRight: Panel;
	sourceFtlOrder: DataSource;
	sourceOrderStop: DataSource;
	textboxBlnum: Textbox;
	textboxConsigneeRefno: Textbox;
	textboxEquipmentTypeId: Textbox;
	textboxPieces: Textbox;
	textboxPlanningComment: Textbox;
	textboxShipperPo: Textbox;
	textboxShipperRef: Textbox;
	textboxWeight: Textbox;
}
